export default __webpack_public_path__ + "fonts/AzeretMono-Bold.ttf";